module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-700italic.283438e9.woff2";